<script lang="ts">
  import type { HTMLInputAttributes } from 'svelte/elements';

  interface Props {
    label: string;
    value?: string;
    type?: 'text' | 'email' | 'password';
    placeholder?: string;
    maxlength?: number;
    autocomplete?: HTMLInputAttributes['autocomplete'];
    disabled?: boolean;
    error?: string;
    name?: string;
    /** Fired when the field is left, for forms that validate on blur. */
    onblur?: () => void;
  }

  let {
    label,
    value = $bindable(''),
    type = 'text',
    placeholder = '',
    maxlength,
    autocomplete = 'off',
    disabled = false,
    error,
    name,
    onblur,
  }: Props = $props();
</script>

<label class="field" class:field--error={Boolean(error)}>
  <span class="field__label">{label}</span>
  <input
    class="field__control"
    bind:value
    {type}
    {name}
    {placeholder}
    {maxlength}
    {autocomplete}
    {disabled}
    {onblur}
    aria-invalid={Boolean(error)}
    aria-describedby={error ? `${name ?? 'field'}-error` : undefined}
  />
  {#if error}
    <span class="field__error" id={`${name ?? 'field'}-error`}>{error}</span>
  {/if}
</label>
